var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',[_c('headerNav')],1),_vm._v(" "),_c('div',{staticClass:"page-content"},[_c('router-view',{on:{"footer":_vm.footer}})],1),_vm._v(" "),(_vm.footer_show)?_c('div',[_c('footerNav')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb7d7ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/com/black/layout.vue
// module id = null
// module chunks = 